import { TileSetMapType, CHARACTER_DIRECTION } from "common/model";

const landscapeLayer1 = [
  [23, 23, 23, 23, 23],
  [31, 31, 23, 31, 23],
  [22, 22, 22, 31, 23],
  [31, 31, 22, 23, 23],
  [31, 31, 22, 22, 22],
];
const landscapeLayer2 = [
  [42, 0, 0, 38, 36],
  [0, 0, 43, 0, 0],
  [1, 0, 10, 0, 0],
  [0, 0, 0, 43, 43],
  [0, 0, 12, 0, 11],
];
const landscapeLayer3 = [
  [0, 0, 0, 0, 0],
  [0, 0, 0, 0, 0],
  [0, 0, 0, 0, 0],
  [0, 0, 0, 0, 0],
  [0, 0, 0, 0, 8],
];

const landscape = [landscapeLayer1, landscapeLayer2, landscapeLayer3];

const map: TileSetMapType = {
  character: {
    direction: CHARACTER_DIRECTION.CHARACTER_DIRECTION_MINUS_X,
  },
  landscape: landscape,
};

export default map;
